export default __webpack_public_path__ + "static/media/map-arrow.97e7a1cd.svg";